import isUndefined from 'lodash/isUndefined'
import isEmpty from 'lodash/isEmpty'
import $api from '@/plugins/axiosInstance.js'
import $api2 from '@/plugins/axiosInstance2.js'
import CONST from '@/const'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
    GET_AGGREGATOR: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: '/aggregator', params: payload})
            .then(result =>{return result.data})
        }
    },
    DETAIL_AGGREGATOR: {
        root: true,
        handler(namespacedContext, payload) {
          return $api({ method: 'get', url: '/aggregator/'+payload.id,}).then((result) => {
            return result
          })
        }
    },
   
    POST_AGGREGATOR: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'post', url: '/aggregator', data: payload})
            .then(result =>{return result.data})
        }
    },
    PUT_AGGREGATOR: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'put', url: '/aggregator/'+payload.id, data: payload})
            .then(result =>{return result.data})
        }
    },
    DELETE_AGGREGATOR: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'delete', url: '/aggregator/'+payload.id,})
            .then(result =>{return result.data})
        }
    },
    POST_SALESLINEGROUP: {
        root: true,
        handler(namespacedContext, payload) { 
            const formData = new FormData()
            formData.append('file', payload.file)
            formData.set('aggregator_id', payload.params.aggregator_id)
            return $api({  method: 'post', url: `saleslinegroup`,headers: {
            'Content-Type': 'multipart/form-data',
            },data: formData,}).then((result) => {
            return result
            })
        }
    },
    DELETE_SALESLINEGROUP : {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'delete', url: '/saleslinegroup/'+ payload.id})
            .then(result =>{return result.data})
        }
    },
    GET_SALESLINEGROUP: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: '/saleslinegroup', params: payload})
            .then(result =>{return result.data})
        }
    },
    GET_SALESLINEGROUP_NOTICES: {
        root: true,
        handler(namespacedContext, payload) {
            return $api({ method: 'get', url: `/saleslinegroup/${payload.id}/notices` })
                .then(result => result.data)
        }
    },
    PUT_DEPOSIT_COMPLETE: {  
        root: true,
        handler(namespacedContext, payload){
        return $api({method: 'put', url: '/saleslinegroup/'+ payload.id + '/deposit_complete', data: payload.params})
        .then(result =>{
            return result
        })
        }
    },
    GET_SALESLINEGROUP_ITEM: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: `/saleslinegroup/${payload.id}/saleslinetemp`,})
            .then(result =>{return result.data})
        }
    },
    GET_SALESLINEGROUP_ITEM_ERROR: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: `/saleslinegroup/${payload.id}/saleslinetemp`, params : payload.params})
            .then(result =>{return result.data})
        }
    },
    // 검수 수정 - type에 따른 api url 변경
    PUT_ITEM_ERROR: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'put', url: `/saleslinegroup/${payload.id}/saleslinetemp/${payload.type}`, data : payload.params})
            .then(result =>{return result.data})
        }
    },
    //검수 요청
    POST_SALES_VALIDADATE: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'post', url: `/saleslinegroup/${payload.id}/saleslinetemp/validate`, })
            .then(result =>{return result.data})
        }
    },
    // 계약사 id로 계약사에 포함된 운영사 리스트 호출
    GET_OPERATE_LIST : {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: `/aggregator/${payload.id}/operator`, params : payload.params})
            .then(result =>{return result.data})
        }
    },
    // 전체 운영사 리스트 호출
    GET_OPERATE_LIST_V2 : {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: `/operator`, params : payload.params})
            .then(result =>{return result.data})
        }
    },
    // 계약사 id로 계약사에 운영사 추가 (이름만 추가)
    saveOperate : {
        root: true,
        handler(namespacedContext, payload){
        return $api({method: 'post', url: '/aggregator/'+ payload.id + '/operator', data: payload.params})
        .then(result =>{
            return result
        })
        }
    },
    OK_MATCH : {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'PUT', url: `/saleslinegroup/${payload.id}/saleslinetemp/ok-match`, data : payload.params})
            .then(result =>{return result.data})
        }
    },
    RE_MATCH : {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'PUT', url: `/saleslinegroup/${payload.id}/saleslinetemp/re-match`, data : payload.params})
            .then(result =>{return result.data})
        }
    },
    IGNORE : {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'PUT', url: `/saleslinegroup/${payload.id}/saleslinetemp/ignore`, data : payload.params})
            .then(result =>{return result.data})
        }
    },
    SALES_AMOUNT_LIST : {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'GET', url: `/saleslinegroupamount`, params : payload.params})
            .then(result =>{return result.data})
        }
    },
    SALES_EXCHANGE : {
        // {
        //     "currency": "eur",
        //     "exchange_date": "2021-02-25",
        //     "exchange_rate": 1103.37,
        //     "slga": [
        //         1002,
        //         1012,
        //         1024
        //     ]
        // }
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'POST', url: `/saleslinegroupamount/exchange`, data : payload})
            .then(result =>{return result.data})
        }
    },
    SALES_OPEN : {
        // {
        //     "currency": "eur",
        //     "slga": [
        //       1002,
        //       1012,
        //       1024
        //     ]
        // }
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'POST', url: `/saleslinegroupamount/open`, data : payload})
            .then(result =>{return result.data})
        }
    },

    GET_SALESLINE_ACCOUNTS_EXCEL: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: '/salesline/export/settleaccounts', params: payload})
            .then(result =>{return result.data})
        }
    },
    GET_SALESLINE_TEMP_EXCEL: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: `/saleslinegroup/${payload.id}/saleslinetemp/export`, })
            .then(result =>{return result.data})
        }
    },

    // SLGA list (v1 — same DB until v2 endpoint exists)
    LIST_SLGA: {
        root: true,
        handler(namespacedContext, payload) {
            return $api({ method: 'GET', url: '/saleslinegroupamount', params: payload.params })
                .then(result => result.data)
        }
    },

    // v2 exchange-log
    LIST_EXCHANGE_LOG: {
        root: true,
        handler(namespacedContext, payload) {
            return $api2({ method: 'get', url: '/admin/exchange-log', params: payload })
                .then(result => result.data)
        }
    },
    DETAIL_EXCHANGE_LOG: {
        root: true,
        handler(namespacedContext, payload) {
            return $api2({ method: 'get', url: `/admin/exchange-log/${payload.id}` })
                .then(result => result.data)
        }
    },
    POST_EXCHANGE_LOG: {
        root: true,
        handler(namespacedContext, payload) {
            return $api2({ method: 'post', url: '/admin/exchange-log', data: payload })
                .then(result => result.data)
        }
    },

    // v2 open-log
    LIST_OPEN_LOG: {
        root: true,
        handler(namespacedContext, payload) {
            return $api2({ method: 'get', url: '/admin/open-log', params: payload })
                .then(result => result.data)
        }
    },
    DETAIL_OPEN_LOG: {
        root: true,
        handler(namespacedContext, payload) {
            return $api2({ method: 'get', url: `/admin/open-log/${payload.id}` })
                .then(result => result.data)
        }
    },
    POST_OPEN_LOG: {
        root: true,
        handler(namespacedContext, payload) {
            return $api2({ method: 'post', url: '/admin/open-log', data: payload })
                .then(result => result.data)
        }
    },

}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
